import React, { useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import MainSlider from '../components/MainSlider';
import DonateOne from '../components/DonateOne';
import AboutOne from '../components/AboutOne';
import ServicesOne from '../components/ServicesOne';
import BecomeVolunteer from '../components/BecomeVolunteer';
import CausesOne from '../components/CausesOne';
import CounterOne from '../components/CounterOne';
import VideoOne from '../components/VideoOne';
import Footer from '../components/Footer';
import TeamOne from '../components/TeamOne';
import MobileNav from '../components/MobileNav';
import SearchPopup from '../components/SearchPopup';
import BrandOne from '../components/BrandOne';
import TestimonialOne from '../components/TestimonialOne';
import DonationOne from '../components/DonationOne';
import FAQOne from '../components/FAQOne';
import BlogOne from '../components/BlogOne';
import GalleryOne from '../components/GalleryOne';

const Home = () => {
  useEffect(() => {
    // Ensure body has the required class for custom cursor script
    document.body.classList.add('custom-cursor');

    // Hide preloader in case window 'load' fired before script.js attached
    const hidePreloader = () => {
      // Use jQuery if present to respect original fade timings
      if (window.$) {
        window.$('.js-preloader').delay(300).fadeOut(200);
      } else {
        const el = document.querySelector('.js-preloader');
        if (el) {
          setTimeout(() => {
            el.style.transition = 'opacity 200ms ease';
            el.style.opacity = '0';
            setTimeout(() => {
              el.style.display = 'none';
            }, 220);
          }, 300);
        }
      }
    };

    if (document.readyState === 'complete') {
      hidePreloader();
    } else {
      window.addEventListener('load', hidePreloader);
    }
    return () => {
      window.removeEventListener('load', hidePreloader);
    };
  }, []);

  useEffect(() => {
    // Try to (re)initialize AOS/WOW if present
    if (window.AOS && typeof window.AOS.init === 'function') {
      window.AOS.init({ duration: 1200, easing: 'ease', mirror: true });
    }
    if (window.WOW && typeof window.WOW === 'function') {
      try {
        const wow = new window.WOW({ boxClass: 'wow', animateClass: 'animated', mobile: true, live: true });
        wow.init();
      } catch (_) {}
    }

    // Initialize required jQuery plugins for sections present on this page
    if (window.$) {
      const $ = window.$;
      // Main slider
      if ($('.main-slider__carousel').length && typeof $('.main-slider__carousel').owlCarousel === 'function' && !$('.main-slider__carousel').hasClass('owl-loaded')) {
        $('.main-slider__carousel').owlCarousel({
          loop: true,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          margin: 0,
          nav: true,
          dots: true,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          navText: [
            '<span class="icon-right-arrow"></span>',
            '<span class="icon-right-arrow"></span>'
          ],
          responsive: { 0: { items: 1 }, 600: { items: 1 }, 800: { items: 1 }, 992: { items: 1 } }
        });
      }

      // Donate carousels
      if ($('.donate-one-left__carousel').length && typeof $('.donate-one-left__carousel').owlCarousel === 'function' && !$('.donate-one-left__carousel').hasClass('owl-loaded')) {
        $('.donate-one-left__carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 }, 1320: { items: 1 } }
        });
      }
      if ($('.donate-one-right__carousel').length && typeof $('.donate-one-right__carousel').owlCarousel === 'function' && !$('.donate-one-right__carousel').hasClass('owl-loaded')) {
        $('.donate-one-right__carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 }, 1320: { items: 1 } }
        });
      }

      // Causes carousel
      if ($('.causes-one__carousel').length && typeof $('.causes-one__carousel').owlCarousel === 'function' && !$('.causes-one__carousel').hasClass('owl-loaded')) {
        $('.causes-one__carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 2 }, 992: { items: 3 }, 1200: { items: 3 }, 1320: { items: 3 } }
        });
      }

      // Magnific video popup
      if ($('.video-popup').length && typeof $('.video-popup').magnificPopup === 'function') {
        $('.video-popup').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: true,
          fixedContentPos: false
        });
      }

      // Brand One carousel
      if ($('.brand-one__carousel').length && typeof $('.brand-one__carousel').owlCarousel === 'function' && !$('.brand-one__carousel').hasClass('owl-loaded')) {
        $('.brand-one__carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: {
            0: { items: 1 },
            768: { items: 2 },
            992: { items: 3 },
            1200: { items: 4 },
            1320: { items: 5 }
          }
        });
      }

      // Testimonial One carousel with thumbs sync
      if ($('.testimonial-one__carousel').length && $('.testimonial-one__thumb-carousel').length) {
        const $big = $('.testimonial-one__carousel');
        const $thumbs = $('.testimonial-one__thumb-carousel');
        if (!$big.hasClass('owl-loaded')) {
          $big.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: true,
            dots: false,
            loop: true
          }).on('changed.owl.carousel', syncPosition);
        }
        if (!$thumbs.hasClass('owl-loaded')) {
          $thumbs.on('initialized.owl.carousel', function () {
            $thumbs.find('.owl-item').eq(0).addClass('current');
          }).owlCarousel({
            items: 4,
            dots: true,
            nav: false,
            smartSpeed: 700,
            slideBy: 4
          }).on('changed.owl.carousel', syncPosition2);
        }

        function syncPosition(el) {
          const count = el.item.count - 1;
          let current = Math.round(el.item.index - el.item.count / 2 - 0.5);
          if (current < 0) current = count;
          if (current > count) current = 0;
          $thumbs.find('.owl-item').removeClass('current').eq(current).addClass('current');
          const onscreen = $thumbs.find('.owl-item.active').length - 1;
          const start = $thumbs.find('.owl-item.active').first().index();
          const end = $thumbs.find('.owl-item.active').last().index();
          if (current > end) $thumbs.data('owl.carousel').to(current, 500, true);
          if (current < start) $thumbs.data('owl.carousel').to(current - onscreen, 500, true);
        }
        function syncPosition2(el) {
          const number = el.item.index;
          $big.data('owl.carousel').to(number, 500, true);
        }
        $thumbs.on('click', '.owl-item', function (e) {
          e.preventDefault();
          const number = $(this).index();
          $big.data('owl.carousel').to(number, 500, true);
        });
      }

      // Gallery One carousel
      if ($('.gallery-one__carousel').length && typeof $('.gallery-one__carousel').owlCarousel === 'function' && !$('.gallery-one__carousel').hasClass('owl-loaded')) {
        $('.gallery-one__carousel').owlCarousel({
          loop: true,
          margin: 5,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: {
            0: { items: 1 },
            768: { items: 2 },
            992: { items: 3 },
            1200: { items: 4 },
            1320: { items: 5 }
          }
        });
      }

      // Footer widget (Twitter) carousel
      if ($('.footer-widget__carousel').length && typeof $('.footer-widget__carousel').owlCarousel === 'function' && !$('.footer-widget__carousel').hasClass('owl-loaded')) {
        $('.footer-widget__carousel').owlCarousel({
          loop: true,
          margin: 0,
          nav: false,
          dots: true,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 }, 1320: { items: 1 } }
        });
      }
    }
  }, []);

  return (
    <>
      {/* Mobile Nav and Search Popup expected by template scripts */}
      <MobileNav />
      <SearchPopup />
      {/* Custom cursors */}
      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>

      {/* Preloader */}
      <div className="loader js-preloader">
        <div></div>
        <div></div>
        <div></div>
      </div>

      {/* Sidebar (outside page-wrapper) */}
      <Sidebar />

      {/* Page Wrapper */}
      <div className="page-wrapper">
        {/* Header */}
        <Header />

        {/* Sticky header placeholder */}
        <div className="stricky-header stricked-menu main-menu">
          <div className="sticky-header__content"></div>
        </div>

        {/* Sections */}
        <MainSlider />
        <DonateOne />
        <AboutOne />
        <ServicesOne />
        <BecomeVolunteer />
        <CausesOne />
        <CounterOne />
        <VideoOne />
        <TeamOne />
        {/* <BrandOne /> */}
        <TestimonialOne />
        <DonationOne />
        <FAQOne />
        {/* <BlogOne /> */}
        <GalleryOne />

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Home;
